export type FrequencyOptions =
  | 'single'
  | 'daily'
  | 'weekly'
  | 'bi_weekly'
  | 'monthly'
  | 'bi_monthly'
  | 'quarterly'
  | 'quadrimester'
  | 'semiannual'
  | 'annual'

export enum Options {
  template = 'template',
  custom = 'custom',
  workflow = 'workflow',
}

export enum Templates {
  climate = 'climate',
  workflow = 'workflow_survey',
}

export enum Types {
  custom = Options.custom,
  climate = Templates.climate,
  workflow = Templates.workflow,
}
